import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrandingProvider } from './contexts/BrandingContext';
import { AuthProvider } from './contexts/AuthContext';
import { UnidadeProvider } from './contexts/UnidadeContext';
import { ContextProvider } from './contexts/ContextProvider';
import AppRoutes from './routes';
import theme from './theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <BrandingProvider>
            <AuthProvider>
              <UnidadeProvider>
                <ContextProvider>
                  <AppRoutes />
                </ContextProvider>
              </UnidadeProvider>
            </AuthProvider>
          </BrandingProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
